import { connect } from "react-redux";
import HorizontalScrollList from "./HorizontalScrollList";
import { changePage } from "../../redux/actions";
// import { appNavigationInfo } from "../../redux/reducers/appNavigation";

const mapStateToProps = state => {
    return Object.assign({}, {
        appNavigation: state.appNavigation,
        appInformation: state.appInformation,
    });
};

const mapDispatchToProps = dispatch => {
    return {
        changePage: (nextPage, subCategory, query) => dispatch(changePage(nextPage, subCategory, query, dispatch)),

    };
};

const HorizontalScrollListContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(HorizontalScrollList);

export default HorizontalScrollListContainer;
